"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformReducers = void 0;
const apis_1 = require("../apis");
const platformSlice_1 = require("./platformSlice");
exports.platformReducers = {
    platform: platformSlice_1.platformSlice.reducer,
    [apis_1.publicDataApi.reducerPath]: apis_1.publicDataApi.reducer,
};
